export default __webpack_public_path__ + "static/media/50.8fce305f.jpg";